<div class="container py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="mb-0">Entregar</h2>
    <button
      mat-icon-button
      (click)="refresh()"
      [disabled]="loading"
      [ngClass]="{ 'refresh-loading': loading }"
      aria-label="Actualizar"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div *ngIf="!loading && loadError" class="text-center py-4">
    <mat-icon
      class="text-danger"
      style="font-size: 40px; width: 40px; height: 40px"
      >error_outline</mat-icon
    >
    <p class="mt-2 mb-3 text-danger">Ocurrió un error al cargar los ítems.</p>
    <button mat-stroked-button color="primary" (click)="refresh()">
      Reintentar
    </button>
  </div>

  <div
    *ngIf="!loading && !loadError && orders.length === 0"
    class="text-center py-5"
  >
    <mat-icon
      class="text-muted"
      style="font-size: 48px; width: 48px; height: 48px"
      >check_circle_outline</mat-icon
    >
    <p class="mt-3 text-muted">No hay ítems para mostrar</p>
  </div>

  <div class="grid">
    <mat-card *ngFor="let ord of orders" class="ready-card" tabindex="0">
      <mat-card-header>
        <div class="title-row">
          <span class="table"
            >{{ ord.customerName || ord.tableName || 'Mesa' }}</span
          >
          <span class="dot">•</span>
          <span class="time">{{ timeFrom(ord.since) }}</span>
          <span class="dot" *ngIf="ord.orderId">•</span>
          <span class="order-id" *ngIf="ord.orderId">#{{ ord.orderId }}</span>
          <span class="dot">•</span>
          <span class="badge status" [ngClass]="statusClass(ord.status)"
            >{{ ord.status | uppercase }}</span
          >
        </div>
      </mat-card-header>
      <mat-card-content>
        <div>
          <div
            *ngFor="let grp of ord.groups"
            class="d-flex justify-content-between align-items-center mb-2"
          >
            <div>
              <strong>{{ grp.qty }}x {{ grp.name }}</strong>
              <div class="small mt-1">
                <span
                  class="badge inline status"
                  [ngClass]="statusClass(grp.status)"
                  >{{ grp.status | uppercase }}</span
                >
              </div>
              <div
                *ngIf="grp.options && grp.options.length > 0"
                class="text-muted small mt-1"
              >
                <div *ngFor="let op of grp.options">
                  {{ op.qty }} x {{ op.name }}
                </div>
              </div>
            </div>
            <div class="d-flex gap-2">
              <button
                mat-stroked-button
                color="primary"
                class="btn-advance"
                (click)="onAdvanceGroup(ord, grp)"
                [disabled]="grp.isAdvancing || !nextStatus(grp)"
                [ngClass]="{ 'btn-advancing': grp.isAdvancing }"
                aria-label="Avanzar"
              >
                <ng-container *ngIf="!grp.isAdvancing; else loadingTpl"
                  >Avanzar</ng-container
                >
                <ng-template #loadingTpl>
                  <mat-icon class="spin">refresh</mat-icon>
                </ng-template>
              </button>
            </div>
          </div>
          <div class="d-flex gap-2 mt-2">
            <button
              mat-stroked-button
              color="accent"
              (click)="openOrder(ord)"
              *ngIf="ord.tableUuid && ord.orderUuid"
            >
              Ver Orden
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
